const TEXT = {
    AGENT:"代理系统",
    Index:"首页",
    Order:"订单",
    Team:"团队",
    TeamInfo:"团队信息",
    TeamNum:"团队人数",
    TeamNewAdd:"团队新增人数",
    TeamAchievement:"团队业绩",
    TeamAgentType:"团队人数",
    MyHome:"我的",
    AgentHome:"工作台", 
    Address:"选择收货地址",
    ApplyHome:"申请代理",
    ApplyStep1:"申请代理",
    ApplyStep2:"申请代理",
    ApplyStep3:"申请代理",
    ApplyStep4:"申请代理",
    ApplyStep5:"申请代理",
    Invite:"邀请代理", 
    Audit:"代理审核", 
    Reward:"奖励",
    ViewBrandList:"品牌选择", 
    RewardBrandList:"品牌选择",
    Achievement:"我的业绩",
    Relative:"进货关系网",
    Relativebrand:"进货关系网",
    Relativebrandlist:"品牌选择",
    Invrelative:"邀请关系网",
    Auth:"我的授权",
    AuthList:"我的授权",
    AddAuth:"添加代理授权",
    AuthSuccess:"添加代理授权成功",
    Shop:"进货",
    SubmitOrders:"确认订单",
    SubmitSuccess:"支付成功",
    Login:"登录",
    SetUp:"设置",
    MyInfo:"更新信息",
    UpdatePwd:"修改密码",
    MyAddress :"收货地址",
    AddAddress:"添加收货地址",
    UpdateAddress :"编辑收货地址",
    MyBank:"常用银行卡",
    AddMyBank :"添加银行卡",
    MyPayment:"收款账号",
    MyAlipay:"支付宝收款账号",
    AddAlipay:"添加支付宝收款账号",
    WeChat:"微信收款账号",
    AddWeChat:"添加微信收款账号",
    Transfer:"我要充值",
    TransferDetails :"充值详情",
    MyAuth:"我的授权",
    MyOrders:"我的订单",
    SubOrders:"下级进货订单",//下级进货订单
    TwosubOrders:"下级订单",//下级订单
    TeamsubOrders:"团队订单",//团队订单
    OrderDetails:"订单详情", 
    Message:"消息", //消息页面
    Messagedetail:"消息详情",    //系统消息详情页面
    Updaterecord:"我的升级记录", //我的升级记录
    Mybrandlist:"品牌选择",  //我的部分品牌选择
    Cashdeposit:"保证金",  //保证金
    PayCashdeposit:"缴纳保证金",  //缴纳保证金
    UploadCashdeposit:"保证金凭证上传",//保证金上传凭证页面
    Myshop:"我的小店",//我的小店
    MyshopBuy:"小店",//xx的小店                  更改页面自行实现
    Clock:"我的秒杀", //我的小店秒杀
    ClockEdit:"小店秒杀编辑",//我的小店秒杀编辑
    GroupShopping:"我的拼团", //我的拼团秒杀
    GroupShoppingEdit:"小店拼团编辑",//我的小店拼团编辑
    Bargain:"我的砍价", //我的小店砍价
    BargainEdit:"小店砍价编辑",//我的小店砍价编辑
    ProductDetail:"商品详情",//商品详情
    InviteAgentTypelist:"邀请新代理",
    InviteBrandList :"选择品牌",
    Inviteuser :"微信代理授权",
    AuditBrand :"选择品牌",
    AuditBrandList:"选择品牌",
    InvrelativeBrand :"选择品牌",
    InvrelativeBrandList :"选择品牌",
    AchievementBrandList :"选择品牌",
    Stock :"仓库",
    ActualStockDetail :"实体库存",
    VirtualStockDetail:"云库存",
    ShopBrandList :"品牌选择",
    TakeGoods :"立即提货",
    StockSubmitOrders :"确认订单",
    StockSubmitSuccess :"支付成功",
    StockOrderList :"提货订单",
    AgentQuery :"AgentQuery",
    AgentQueryResult :"AgentQueryResult",
    AuditOrders :"AuditOrders",
    AuditOrdersDetail:"AuditOrders",
    Security :"Security",
    SecurityResult :"SecurityResult",
    ThirdPartyLogin :"登录",
    MyReward :"我的业绩",//我的业绩页面
    QRDelivery :"QRDelivery",
    Wallet :"我的钱包",
    Settlement :"结算",
    Recharge:"货款充值",
    Income :"收入账单",
    Spending:"支出账单",
    Upgrade:"我要升级",
    UpgradeBrandList :"选择品牌",
//扫码发货
    SweepCodeDelivery :"扫码发货",
    DeliveryRecord:"扫码记录",
    DeliveryRecordDetail :"扫码记录详情",
    DeliverySelectAgent :"选择收货人",
    DeliveryLogisticsCode :"添加条码/扫码",
    expressInfo:"添加物流信息",
    DeliveryBrandList :"品牌选择",
    Report :"报表",
    SubTransfer:"下级充值",
    SubTransferAgents:"下级充值",
    subTransferAudit:"下级货款审核",
    MonthReward :"月度业绩奖励",
    OnceReward :"邀请一次性奖励",
    OrderReward:"邀请订单奖励",
    SpendingReward:"支出奖励账户",
    WithdrawalReward :"提现奖励用户",
    Withdrawal :"提现",
    PaymentCert :"付款凭证",
    TeamAchievementBrandList :"品牌选择",
    WalletWithdrawal :"提现中",
    AchievementDatails:"我的业绩明细",
    TeamAchievementInfo:"团队业绩",
    UpgradeReward:"升级订单奖励",
    TopLevelPushReward:"顶级平推奖励",
    NoTopLevelPushReward:"非顶级平推奖励",
    InternalOrders:"内购订单",		
    InternalShop:"内购商城",
    Remind:"待办提醒",
    Promote:"推广合作",
    PromoteDetail:"合作详情",
    SourceCenter:"素材中心",
    SourceDetail:"素材详情",
    MySource:"我的素材",
    agentInfo:"代理商详情",
    Lead:"Welcome",
    Register:"注册",
    EditPassword:"修改密码",
    ForgotPassword:"重置密码",
    AddBrandStep:"添加品牌",
    TransferSuccess:"充值成功",
    Certification:"实名认证",
    CertificationInfo:"实名认证",

    MyshopSubmitOrders:"订单提交",
    MyshopAddress:"我的地址",
    MyshopAddressAdd:"地址添加",
    MyshopAddressUpdate:"地址编辑",
    MyshopSubmitOrdersSuccess:"提交成功",
    DelOpenid:"微信解绑",
    ErrorPage:"出错啦！",
    searchAnticodeCode:"防伪码信息查询",
    SkuPriceSheet:"产品报价单",
    OrderLogistics:"物流信息",
    TeamRank:"龙虎榜",
    ResetAuth:"代理授权展期申请",
    SubOrderDetails:"下级订单详情",
    SubQRDelivery:"下级订单扫码发货",
    SubTransferAuthList:"授权列表",
    MonthlySettlement:"月结账单",
};


export {
    TEXT
}


// WEBPACK FOOTER //
// ./src/config/page/cn/title/index.js